// UserContext.js
import React, { createContext, useState } from 'react';

// Create a Context
export const UserContext = createContext();

// Create a Provider component
export const UserProvider = ({ children }) => {
    const [username, setUsername] = useState(''); // Initialize with an empty string

    // setUsername(sessionStorage.username);
    return (
        <UserContext.Provider value={{ username, setUsername }}>
            {children}
        </UserContext.Provider>
    );
};